import React, { useState, useEffect } from 'react';
import AddDepartamento from './AddDepartamento';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionDepartamentos() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [departamentos, setDepartamentos] = useState([]);
    const [editDepto, setEditDepto] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [deptoToDelete, setDeptoToDelete] = useState(null);
    const { user } = useUser();

    const fetchDepartamentos = async () => {
        try {
            const response = await fetch(`${server}/MgDepartamentoes`);
            const data = await response.json();
            setDepartamentos(data.$values);
            console.log(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los paises: ' + error.message,
            });
        }
    };

    useEffect(() => {
        fetchDepartamentos();
    }, []);

    const handleNewDepto = () => {
        fetchDepartamentos();
        setEditDepto(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (depto) => {
        setDeptoToDelete(depto);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setDeptoToDelete(null);
    };

    const handleDeleteDepto = async () => {
        if (deptoToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                
                const response = await fetch(`${server}/MgDepartamentoes/${deptoToDelete.idDepartamento}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchDepartamentos(); // Recargar la lista de departamentos
                   
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Departamento eliminado con éxito',
                    });

                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el departamento: ' + error.message,
                });
            }
        }
    };

    const filteredDepartamentos = departamentos.filter(depto => depto.nombreDepartamento?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddDepartamento handleNewDepto={handleNewDepto} editDepto={editDepto} />
                <div className="ln_solid" />

                <h2>Departamentos Existentes</h2>

                <div className="row">
                    <div className="col-md-7 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar departamento"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nombre del Pais</TableCell>
                                        <TableCell>Nombre del Departamento</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredDepartamentos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((depto) => (
                                        <TableRow key={depto.idDepartamento}>
                                            <TableCell component="th" scope="row">{depto.nombrePais}</TableCell>
                                            <TableCell>{depto.nombreDepartamento}</TableCell>
                                            <TableCell align="right">
                                                <Button onClick={() => setEditDepto(depto)} color="primary" disabled={!tienePermiso('Editar Departamento')}>Editar</Button>
                                                <Button onClick={() => handleOpenDialog(depto)} color="secondary" disabled={!tienePermiso('Eliminar Departamento')}>Eliminar</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredDepartamentos.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>
                        <Dialog
                            open={openDialog}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que deseas eliminar el departamento seleccionado?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteDepto} color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionDepartamentos;
